import { Button, Drawer } from 'core-ui';
import { styled } from 'core-ui-2';
import SideMenu from './SideMenu';
import { AvatarIcon, LogoutIcon, MenuUnfoldIcon } from 'src/assets/icons';
import { truncateText } from 'src/utils/text';
import { handleAdminLogout } from 'src/services/auth';

const StyledDrawer = styled(Drawer)`
  .ant-drawer-header {
    background-color: #5272bd;
    height: 64px;
    padding-left: 15px;
    padding-right: 15px;
    .ant-drawer-header-title {
      justify-content: space-between;
      .ant-drawer-title {
        flex: none;
      }
    }
  }
  .ant-drawer-body {
    padding: 0;
  }
  .ant-drawer-footer {
    padding-bottom: 28px;
    border-top: none;
  }
`;

interface Props {
  open: boolean;
  onClose: () => void;
  userName: string;
}

const MobileDrawer: React.FC<Props> = ({ open, onClose, userName }) => {
  return (
    <StyledDrawer
      open={open}
      onClose={onClose}
      placement="left"
      width={260}
      rootClassName="z-[2001]"
      closeIcon={<img src={MenuUnfoldIcon} alt="menu unfold icon" />}
      title={
        <div className="flex cursor-pointer items-center">
          <div className="w-10 h-10 rounded-full overflow-hidden">
            <img
              src={AvatarIcon}
              alt="avatar"
              className="w-full h-full object-cover"
              crossOrigin="anonymous"
            />
          </div>

          <div className="ml-3">
            <p className="leading-5 font-medium text-white text-sm">
              {truncateText(userName, 11)}
            </p>
          </div>
        </div>
      }
      footer={
        <Button
          className="text-custom-error8 border border-custom-error8 w-full py-5 text-xs"
          icon={<img src={LogoutIcon} alt="log out icon" />}
          onClick={handleAdminLogout}
        >
          <span>ログアウト</span>
        </Button>
      }
    >
      <SideMenu onItemClick={onClose} />
    </StyledDrawer>
  );
};

export default MobileDrawer;
